import React, { useEffect, useRef, useState, } from "react";







import I from "./Icon";







import apiService from "../services/apiService";















const ROLE_API_PATH =







  "UserRole/getAllUserRoles?includeInActive=true";







const getRoleId = (role) =>







  role?.id ??







  role?.Id ??







  role?.roleId ??







  role?.RoleId ??







  "";















const getRoleName = (role) =>







  role?.roleName ??







  role?.RoleName ??







  role?.name ??







  role?.Name ??







  "";















const isRoleActive = (role) => {







  const value =







    role?.isActive ??







    role?.IsActive;







  if (







    value === undefined ||







    value === null







  ) {







    return true;







  }







  return (







    value === true ||







    value === 1 ||







    value === "1" ||







    String(value).toLowerCase() ===







    "true"







  );







};















const getArrayFromResponse = (data) => {







  if (Array.isArray(data)) {







    return data;







  }















  if (Array.isArray(data?.output)) {







    return data.output;







  }















  if (Array.isArray(data?.Output)) {







    return data.Output;







  }















  if (Array.isArray(data?.data)) {







    return data.data;







  }















  if (Array.isArray(data?.Data)) {







    return data.Data;







  }















  if (Array.isArray(data?.result)) {







    return data.result;







  }















  if (Array.isArray(data?.Result)) {







    return data.Result;







  }















  return [];







};















const showNotification = (



  type,



  message



) => {



  if (



    typeof document === "undefined" ||



    typeof window === "undefined"



  ) {



    return;



  }







  const existingNotification =



    document.getElementById(



      "profile-panel-notification"



    );







  if (existingNotification) {



    existingNotification.remove();



  }







  const notification =



    document.createElement("div");







  notification.id =



    "profile-panel-notification";







  notification.textContent =



    `${type === "success" ? "✓" : "✕"} ${message}`;







  Object.assign(



    notification.style,



    {



      position: "fixed",



      top: "20px",



      right: "20px",



      zIndex: "99999",



      minWidth: "280px",



      maxWidth: "420px",



      padding: "12px 16px",



      borderRadius: "8px",



      backgroundColor:



        type === "success"



          ? "#d1e7dd"



          : "#f8d7da",



      color:



        type === "success"



          ? "#0f5132"



          : "#842029",



      border:



        type === "success"



          ? "1px solid #badbcc"



          : "1px solid #f5c2c7",



      fontSize: "14px",



      fontWeight: "600",



      boxShadow:



        "0 4px 12px rgba(0,0,0,0.15)",



    }



  );







  document.body.appendChild(



    notification



  );







  window.setTimeout(() => {



    if (notification.parentNode) {



      notification.remove();



    }



  }, 3000);



};











function Bdg({ type, label }) {







  return (







    <span







      className={`bdg bdg-${type[0]}`}







    >







      <span className="bdg-dot"></span>















      {label}







    </span>







  );







}















export default function ProfilePanel({







  onClose,







  toast,







}) {







  const [logoutSuccess, setLogoutSuccess] = useState(false);







  const [editing, setEditing] = useState(false);







  const [showLogoutPopup, setShowLogoutPopup,] = useState(false);







  const [loading, setLoading] = useState(true);







  const [saving, setSaving] = useState(false);







  const [profileError, setProfileError,] = useState("");







  const [userId, setUserId] = useState(null);







  const [originalUser, setOriginalUser,] = useState(null);







  const [roles, setRoles] = useState([]);







  const [roleLoading, setRoleLoading,] = useState(false);







  const [roleError, setRoleError] = useState("");







  const fileInputRef = useRef(null);







  const [selectedFile, setSelectedFile,] = useState(null);







  const [profilePreview, setProfilePreview,] = useState("");







  const [form, setForm] = useState({







    firstName: "",







    middleName: "",







    lastName: "",







    name: "",















    email: "",







    phone: "",















    role: "",







    roleId: "",















    profilePic: "",















    dateOfBirth: "",















    isPasswordSet: false,







    isFirstTime: false,







    isActive: false,







  });















  const set = (key, value) => {







    setForm((previous) => ({







      ...previous,







      [key]: value,







    }));







  };







  const getStoredUser = () => {







    try {







      const storedUserString =







        sessionStorage.getItem(







          "user"







        );















      if (!storedUserString) {







        return {};







      }















      const result =







        JSON.parse(







          storedUserString







        );















      return (







        result?.output ??







        result?.Output ??







        result?.data ??







        result?.Data ??







        result ??







        {}







      );







    } catch (error) {







      console.error(







        "Unable to parse stored user:",







        error







      );















      return {};







    }







  };















  const getLoggedInUserId =







    () => {







      const savedUserId =







        sessionStorage.getItem(







          "userId"







        );















      if (savedUserId) {







        return savedUserId;







      }















      const storedUser =







        getStoredUser();















      return (







        storedUser?.id ??







        storedUser?.Id ??







        storedUser?.userId ??







        storedUser?.UserId ??







        null







      );







    };







  const fetchRoles = async () => {







    try {







      setRoleLoading(true);







      setRoleError("");















      const response =







        await apiService.get(







          ROLE_API_PATH







        );















      const data =







        response.data;















      console.log(







        "Role API Response:",







        data







      );















      if (







        data?.isSuccess === false ||







        data?.IsSuccess === false







      ) {







        throw new Error(







          data?.failureReason ??







          data?.FailureReason ??







          data?.message ??







          data?.Message ??







          "Failed to load roles."







        );







      }















      const roleList =







        getArrayFromResponse(







          data







        );















      console.log(







        "All Role List:",







        roleList







      );















      const activeRoles =







        roleList.filter(







          isRoleActive







        );















      console.log(







        "Active Roles:",







        activeRoles







      );















      setRoles(activeRoles);















      return activeRoles;







    } catch (error) {







      console.error(







        "Role API Error:",







        error







      );















      setRoles([]);







      const message =



        error?.response?.data



          ?.failureReason ??



        error?.response?.data



          ?.FailureReason ??



        error?.response?.data



          ?.message ??



        error?.response?.data



          ?.Message ??



        error?.message ??



        "Unable to load roles.";







      setRoleError(message);







      showNotification(



        "error",



        message



      );







      return [];







    } finally {







      setRoleLoading(false);







    }







  };







  const bindUserToForm = (







    user,







    availableRoles = roles







  ) => {







    if (!user) {







      return;







    }















    const firstName =







      user?.firstName ??







      user?.FirstName ??







      "";















    const middleName =







      user?.middleName ??







      user?.MiddleName ??







      "";















    const lastName =







      user?.lastName ??







      user?.LastName ??







      "";















    const fullName =







      user?.fullName ??







      user?.FullName ??







      [







        firstName,







        middleName,







        lastName,







      ]







        .filter(Boolean)







        .join(" ");















    const roleId =







      user?.roleId ??







      user?.RoleId ??







      user?.role ??







      user?.Role ??







      "";







    let roleName =







      user?.roleName ??







      user?.RoleName ??







      "";







    if (







      !roleName &&







      availableRoles.length > 0







    ) {







      const selectedRole =







        availableRoles.find(







          (role) =>







            String(







              getRoleId(role)







            ) ===







            String(roleId)







        );















      roleName =







        getRoleName(







          selectedRole







        );







    }















    setForm({







      firstName,















      middleName,















      lastName,















      name: fullName,















      email:







        user?.email ??







        user?.Email ??







        "",















      phone:







        user?.mobileNo ??







        user?.MobileNo ??







        "",















      role:







        roleName ?? "",















      roleId:







        roleId !== null &&







          roleId !== undefined







          ? String(roleId)







          : "",















      profilePic:







        user?.profilePic ??







        user?.ProfilePic ??







        "",















      dateOfBirth:







        user?.dateOfBirth ??







        user?.DateOfBirth ??







        "",















      isPasswordSet:







        user?.isPasswordSet ??







        user?.IsPasswordSet ??







        false,















      isFirstTime:







        user?.isFirstTime ??







        user?.IsFirstTime ??







        false,















      isActive:







        user?.isActive ??







        user?.IsActive ??







        false,







    });







  };







  const fetchProfile = async (







    showLoader = true,







    availableRoles = roles







  ) => {







    try {







      if (showLoader) {







        setLoading(true);







      }















      setProfileError("");















      const loggedInUserId =







        getLoggedInUserId();















      console.log(







        "Logged In User ID:",







        loggedInUserId







      );















      if (!loggedInUserId) {







        throw new Error(







          "Logged in user ID not found. Please login again."







        );







      }















      setUserId(







        loggedInUserId







      );















      const response =







        await apiService.get(







          `User/getUserById/${loggedInUserId}`







        );















      const data =







        response.data;















      console.log(







        "Profile API Response:",







        data







      );















      if (







        data?.isSuccess === false ||







        data?.IsSuccess === false







      ) {







        throw new Error(







          data?.failureReason ??







          data?.FailureReason ??







          data?.message ??







          data?.Message ??







          "Failed to load profile."







        );







      }















      const user =







        data?.output ??







        data?.Output ??







        data?.data ??







        data?.Data ??







        data;















      if (!user) {







        throw new Error(







          "User information not found."







        );







      }















      setOriginalUser(user);















      bindUserToForm(







        user,







        availableRoles







      );















      return user;







    } catch (error) {







      console.error(







        "Get Profile API Error:",







        error







      );















      const message =



        error?.response?.data



          ?.failureReason ??



        error?.response?.data



          ?.FailureReason ??



        error?.response?.data



          ?.message ??



        error?.response?.data



          ?.Message ??



        error?.message ??



        "Unable to load profile.";







      setProfileError(message);







      showNotification(



        "error",



        message



      );







      return null;







    } finally {







      if (showLoader) {







        setLoading(false);







      }







    }







  };







  useEffect(() => {







    const loadData =







      async () => {







        setLoading(true);















        try {







          const roleList =







            await fetchRoles();















          await fetchProfile(







            false,







            roleList







          );







        } finally {







          setLoading(false);







        }







      };















    loadData();







  }, []);







  useEffect(() => {







    if (







      !form.roleId ||







      roles.length === 0







    ) {







      return;







    }















    const selectedRole =







      roles.find(







        (role) =>







          String(







            getRoleId(role)







          ) ===







          String(form.roleId)







      );















    if (!selectedRole) {







      return;







    }















    const roleName =







      getRoleName(







        selectedRole







      );















    if (







      roleName &&







      roleName !== form.role







    ) {







      setForm(







        (previous) => ({







          ...previous,







          role: roleName,







        })







      );







    }







  }, [







    roles,







    form.roleId,







    form.role,







  ]);







  const handleCameraClick =







    () => {







      setEditing(true);















      fileInputRef.current?.click();







    };







  const handleProfilePicChange = (







    event







  ) => {







    const file =







      event.target.files?.[0];















    if (!file) {







      return;







    }















    if (



      !file.type.startsWith(



        "image/"



      )



    ) {



      const message =



        "Please select an image file.";







      setProfileError(message);







      showNotification(



        "error",



        message



      );







      return;



    }















    // 5MB







    if (



      file.size >



      5 * 1024 * 1024



    ) {



      const message =



        "Image size must be less than 5 MB.";







      setProfileError(message);







      showNotification(



        "error",



        message



      );







      return;



    }















    setProfileError("");















    setSelectedFile(file);















    if (







      profilePreview?.startsWith(







        "blob:"







      )







    ) {







      URL.revokeObjectURL(







        profilePreview







      );







    }















    const preview =







      URL.createObjectURL(file);















    setProfilePreview(







      preview







    );















    setForm((previous) => ({







      ...previous,















      profilePic:







        file.name,







    }));







  };







  useEffect(() => {







    return () => {







      if (







        profilePreview?.startsWith(







          "blob:"







        )







      ) {







        URL.revokeObjectURL(







          profilePreview







        );







      }







    };







  }, [profilePreview]);







  const getApiErrorMessage = (







    error







  ) => {







    const backendError =







      error?.response?.data;















    console.error(







      "STATUS:",







      error?.response?.status







    );















    console.error(







      "BACKEND RESPONSE:",







      backendError







    );















    if (







      backendError?.errors







    ) {







      const validationMessage =







        Object.values(







          backendError.errors







        )







          .flat()







          .join(" ");















      if (







        validationMessage







      ) {







        return validationMessage;







      }







    }















    if (







      typeof backendError ===







      "string"







    ) {







      return backendError;







    }















    return (







      backendError







        ?.failureReason ??







      backendError







        ?.FailureReason ??







      backendError?.message ??







      backendError?.Message ??







      backendError?.title ??







      error?.message ??







      "Profile update failed."







    );







  };







  const handleUpdateProfile = async () => {







    try {







      setSaving(true);







      setProfileError("");















      if (!userId) {







        throw new Error(







          "User ID not found."







        );







      }















      if (!form.firstName.trim()) {







        throw new Error(







          "First Name is required."







        );







      }















      if (!form.lastName.trim()) {







        throw new Error(







          "Last Name is required."







        );







      }















      if (!form.email.trim()) {







        throw new Error(







          "Email is required."







        );







      }















      if (!form.phone.trim()) {







        throw new Error(







          "Phone Number is required."







        );







      }















      if (!form.dateOfBirth) {







        throw new Error(







          "Date Of Birth is required."







        );







      }















      if (!form.roleId) {







        throw new Error(







          "Please select Role."







        );







      }







      const formData = new FormData();















      formData.append(







        "Id",







        String(userId)







      );















      formData.append(







        "FirstName",







        form.firstName.trim()







      );















      formData.append(







        "MiddleName",







        form.middleName.trim()







      );















      formData.append(







        "LastName",







        form.lastName.trim()







      );















      formData.append(







        "Email",







        form.email.trim()







      );















      formData.append(







        "MobileNo",







        form.phone.trim()







      );















      formData.append(







        "DateOfBirth",







        String(form.dateOfBirth).split("T")[0]







      );















      formData.append(







        "Role",







        String(form.roleId)







      );















      formData.append(







        "ProfilePic",







        selectedFile







          ? selectedFile.name







          : form.profilePic || "profile.png"







      );















      formData.append(







        "IsPasswordSet",







        String(







          Boolean(form.isPasswordSet)







        )







      );















      formData.append(







        "IsFirstTime",







        String(







          Boolean(form.isFirstTime)







        )







      );















      formData.append(







        "IsActive",







        form.isActive ? "1" : "0"







      );















      formData.append(







        "ModifiedBy",







        String(userId)







      );







      formData.append(







        "Hash",







        "frontend-not-used"







      );















      formData.append(







        "Salt",







        "frontend-not-used"







      );















      formData.append(







        "Token",







        "frontend-not-used"







      );















      formData.append(







        "RefreshToken",







        "frontend-not-used"







      );















      formData.append(







        "RefreshTokenExpiryTime",







        new Date(







          Date.now() +







          24 * 60 * 60 * 1000







        ).toISOString()







      );















      formData.append(







        "RoleIds",







        String(form.roleId)







      );















      // Actual image file







      if (selectedFile) {







        formData.append(







          "file",







          selectedFile







        );







      }







      console.log(







        "Update FormData:",







        {







          Id: userId,







          FirstName:







            form.firstName,







          MiddleName:







            form.middleName,







          LastName:







            form.lastName,







          Email:







            form.email,







          MobileNo:







            form.phone,







          DateOfBirth:







            form.dateOfBirth,







          Role:







            form.roleId,







          ProfilePic:







            selectedFile







              ? selectedFile.name







              : form.profilePic,







          IsActive:







            form.isActive,







          ModifiedBy:







            userId,







        }







      );















      const response =







        await apiService.put(







          "User/updateUser",







          formData







        );















      const data =







        response.data;















      console.log(







        "Update User Response:",







        data







      );















      if (







        data?.isSuccess === false ||







        data?.IsSuccess === false







      ) {







        throw new Error(







          data?.failureReason ??







          data?.FailureReason ??







          data?.message ??







          data?.Message ??







          "Profile update failed."







        );







      }







      if (







        profilePreview?.startsWith(







          "blob:"







        )







      ) {







        URL.revokeObjectURL(







          profilePreview







        );







      }















      setProfilePreview("");







      setSelectedFile(null);







      await fetchProfile(







        false,







        roles







      );















      setEditing(false);







      setProfileError("");







      showNotification(



        "success",



        "Profile updated successfully!"



      );







    } catch (error) {







      console.error(







        "Update Profile API Error:",







        error







      );















      console.error(







        "STATUS:",







        error?.response?.status







      );















      console.error(







        "BACKEND RESPONSE:",







        error?.response?.data







      );















      const backendError =







        error?.response?.data;















      let message =







        error?.message ||







        "Profile update failed.";















      if (







        backendError?.errors







      ) {







        message =







          Object.entries(







            backendError.errors







          )







            .map(







              ([key, value]) =>







                `${key}: ${Array.isArray(value)







                  ? value.join(" ")







                  : value







                }`







            )







            .join(" | ");







      } else if (







        typeof backendError ===







        "string"







      ) {







        message =







          backendError;







      } else {







        message =







          backendError?.failureReason ??







          backendError?.FailureReason ??







          backendError?.message ??







          backendError?.Message ??







          backendError?.title ??







          message;







      }















      setProfileError(message);







      showNotification(



        "error",



        message



      );







    } finally {







      setSaving(false);







    }







  };







  const handleCancelEdit =







    () => {







      if (originalUser) {







        bindUserToForm(







          originalUser,







          roles







        );







      }















      if (







        profilePreview?.startsWith(







          "blob:"







        )







      ) {







        URL.revokeObjectURL(







          profilePreview







        );







      }















      setSelectedFile(null);







      setProfilePreview("");







      setProfileError("");







      setEditing(false);







    };







  const getInitials = () => {







    const firstInitial =







      form.firstName







        ?.trim()







      ?.[0] ?? "";















    const lastInitial =







      form.lastName







        ?.trim()







      ?.[0] ?? "";















    if (







      firstInitial ||







      lastInitial







    ) {







      return `${firstInitial}${lastInitial}`.toUpperCase();







    }















    return "U";







  };







  const displayName =







    [







      form.firstName,







      form.middleName,







      form.lastName,







    ]







      .filter(







        (value) =>







          value &&







          String(value).trim()







      )







      .join(" ") ||







    form.name ||







    "-";















  const storedProfilePic =







    form.profilePic ?? "";















  const canDisplayStoredImage =
    /^(https?:\/\/|data:|blob:)/i.test(
      storedProfilePic
    );

  const avatarSource =







    profilePreview ||







    (canDisplayStoredImage







      ? storedProfilePic







      : "");







  const handleLogout = () => {







    try {







      const authKeys = [







        "isLoggedIn",







        "user",







        "userId",







        "token",







        "email",







        "fullName",







        "role",







        "roleIds",







        "permissions",







      ];















      authKeys.forEach((key) => {







        sessionStorage.removeItem(key);







      });















      setLogoutSuccess(true);







      showNotification(



        "success",



        "You have logged out successfully."



      );















      setTimeout(() => {







        window.location.replace("/");







      }, 1200);















    } catch (error) {







      console.error("Logout Error:", error);















      showNotification(



        "error",



        error?.message ||



          "Unable to logout."



      );







      window.location.replace("/");







    }







  };















  if (loading) {







    return (







      <div







        className="ov-panel"







        onClick={onClose}







      >







        <div







          className="ov-panel-inner"







          onClick={(e) =>







            e.stopPropagation()







          }







        >







          <div className="dhdr">







            <div>







              <div







                style={{







                  fontWeight: 700,







                  fontSize: 16,







                }}







              >







                My Profile







              </div>















              <div







                style={{







                  fontSize: 12,







                  color:







                    "var(--t3)",







                  marginTop: 2,







                }}







              >







                Account details







              </div>







            </div>















            <button







              type="button"







              className="close-btn"







              onClick={onClose}







            >







              <I







                n="x"







                s={14}







              />







            </button>







          </div>















          <div







            style={{







              padding:







                "40px 22px",







              textAlign:







                "center",







              color:







                "var(--t3)",







            }}







          >







            Loading profile...







          </div>







        </div>







      </div>







    );







  }















  return (







    <div







      className="ov-panel"







      onClick={onClose}







    >







      <div







        className="ov-panel-inner"







        onClick={(e) =>







          e.stopPropagation()







        }







      >







        <div className="dhdr">







          <div>







            <div







              style={{







                fontWeight: 700,







                fontSize: 16,







              }}







            >







              My Profile







            </div>















            <div







              style={{







                fontSize: 12,







                color: "var(--t3)",







                marginTop: 2,







              }}







            >







              Account details







            </div>







          </div>















          <div







            style={{







              display: "flex",







              gap: 8,







            }}







          >







            <button







              type="button"







              className="btn bo bsm"







              onClick={() => {







                if (editing) {







                  handleCancelEdit();







                } else {







                  setProfileError(







                    ""







                  );















                  setEditing(







                    true







                  );







                }







              }}







            >







              <I n={editing ? "x" : "edit"} s={13} />















              {editing







                ? "Cancel"







                : "Edit"}







            </button>















            <button







              type="button"







              className="close-btn"







              onClick={onClose}







            >







              <I







                n="x"







                s={14}







              />







            </button>







          </div>







        </div>















        <div







          style={{







            padding:







              "24px 22px",







          }}







        >















          {profileError && (







            <div







              style={{







                marginBottom: 20,







                padding:







                  "12px 14px",







                borderRadius: 8,







                background:







                  "rgba(239,68,68,.08)",







                color: "#dc2626",







                fontSize: 13,







              }}







            >







              {profileError}







            </div>







          )}















          <div







            style={{







              textAlign:







                "center",







              marginBottom: 24,







            }}







          >







            <div







              style={{







                position:







                  "relative",







                display:







                  "inline-block",







              }}







            >







              <div







                style={{







                  width: 80,







                  height: 80,















                  borderRadius:







                    "50%",















                  background:







                    "linear-gradient(135deg,#2563EB,#7C3AED)",















                  display: "flex",















                  alignItems:







                    "center",















                  justifyContent:







                    "center",















                  fontSize: 26,















                  fontWeight: 800,















                  color: "#fff",















                  overflow:







                    "hidden",















                  boxShadow:







                    "0 8px 24px rgba(37,99,235,.3)",







                }}







              >







                {avatarSource ? (







                  <img







                    src={







                      avatarSource







                    }







                    alt="Profile"







                    style={{







                      width:







                        "100%",















                      height:







                        "100%",















                      objectFit:







                        "cover",







                    }}







                  />







                ) : (







                  getInitials()







                )}







              </div>















              {editing && (

<button







                type="button"







                title="Change profile photo"







                onClick={







                  handleCameraClick







                }







                style={{







                  position:







                    "absolute",















                  right: -2,







                  bottom: -2,















                  width: 28,







                  height: 28,















                  borderRadius:







                    "50%",















                  border:







                    "2px solid #fff",















                  background:







                    "var(--p)",















                  display: "flex",















                  alignItems:







                    "center",















                  justifyContent:







                    "center",















                  cursor:







                    "pointer",















                  padding: 0,















                  boxShadow:







                    "0 2px 8px rgba(0,0,0,.15)",







                }}







              >







                <I







                  n="camera"







                  s={13}







                  c="#fff"







                />







              </button>

              )}















              <input







                ref={fileInputRef}







                type="file"







                accept="image/*"







                onChange={







                  handleProfilePicChange







                }







                style={{







                  display: "none",







                }}







              />







            </div>















            <div







              style={{







                fontWeight: 800,







                fontSize: 17,







                marginTop: 12,







              }}







            >







              {displayName}







            </div>







            <div







              style={{







                display: "flex",















                justifyContent:







                  "center",















                marginTop: 10,







              }}







            >







              <Bdg







                type={







                  form.isActive







                    ? "green"







                    : "red"







                }







                label={







                  form.isActive







                    ? "Active"







                    : "Inactive"







                }







              />







            </div>







          </div>







          {editing ? (







            <>







              <div







                style={{







                  fontWeight: 700,







                  fontSize: 12.5,















                  color:







                    "var(--t3)",















                  textTransform:







                    "uppercase",















                  letterSpacing:







                    ".07em",















                  marginBottom: 14,







                }}







              >







                Edit Information







              </div>















              <div







                style={{







                  display: "flex",















                  flexDirection:







                    "column",















                  gap: 12,







                }}







              >







                <div className="fg">







                  <label className="fl">







                    First Name *







                  </label>















                  <input







                    className="fi"







                    type="text"







                    value={







                      form.firstName







                    }







                    onChange={(e) =>







                      set(







                        "firstName",







                        e.target.value







                      )







                    }







                  />







                </div>















                <div className="fg">







                  <label className="fl">







                    Middle Name







                  </label>















                  <input







                    className="fi"







                    type="text"







                    value={







                      form.middleName







                    }







                    onChange={(e) =>







                      set(







                        "middleName",







                        e.target.value







                      )







                    }







                  />







                </div>















                <div className="fg">







                  <label className="fl">







                    Last Name *







                  </label>















                  <input







                    className="fi"







                    type="text"







                    value={







                      form.lastName







                    }







                    onChange={(e) =>







                      set(







                        "lastName",







                        e.target.value







                      )







                    }







                  />







                </div>















                <div className="fg">







                  <label className="fl">







                    Email *







                  </label>















                  <input







                    className="fi"







                    type="email"







                    value={







                      form.email







                    }







                    onChange={(e) =>







                      set(







                        "email",







                        e.target.value







                      )







                    }







                  />







                </div>















                <div className="fg">







                  <label className="fl">







                    Phone *







                  </label>















                  <input







                    className="fi"







                    type="tel"







                    value={







                      form.phone







                    }







                    onChange={(e) =>







                      set(







                        "phone",







                        e.target.value







                      )







                    }







                  />







                </div>















                <div className="fg">







                  <label className="fl">







                    Date Of Birth *







                  </label>















                  <input







                    className="fi"







                    type="date"







                    value={







                      form.dateOfBirth







                        ? String(







                          form.dateOfBirth







                        ).split(







                          "T"







                        )[0]







                        : ""







                    }







                    onChange={(e) =>







                      set(







                        "dateOfBirth",







                        e.target.value







                      )







                    }







                  />







                </div>







                <div className="fg">







                  <label className="fl">







                    Role *







                  </label>















                  <select







                    className="fi"







                    value={







                      form.roleId







                    }







                    disabled={







                      roleLoading







                    }







                    onChange={(e) => {







                      const selectedId =







                        e.target







                          .value;















                      const selectedRole =







                        roles.find(







                          (role) =>







                            String(







                              getRoleId(







                                role







                              )







                            ) ===







                            String(







                              selectedId







                            )







                        );















                      setForm(







                        (







                          previous







                        ) => ({







                          ...previous,















                          roleId:







                            selectedId,















                          role:







                            getRoleName(







                              selectedRole







                            ),







                        })







                      );







                    }}







                  >







                    <option value="">







                      {roleLoading







                        ? "Loading Roles..."







                        : "Select Role"}







                    </option>















                    {roles.map(







                      (role) => {







                        const id =







                          getRoleId(







                            role







                          );















                        const name =







                          getRoleName(







                            role







                          );















                        return (







                          <option







                            key={







                              id







                            }







                            value={







                              id







                            }







                          >







                            {







                              name







                            }







                          </option>







                        );







                      }







                    )}







                  </select>















                  {roleError && (







                    <div







                      style={{







                        fontSize: 11,







                        color:







                          "#dc2626",







                        marginTop: 5,







                      }}







                    >







                      {roleError}







                    </div>







                  )}







                </div>







              </div>







              <div







                style={{







                  display: "flex",







                  gap: 10,







                  marginTop: 18,







                }}







              >







                <button







                  type="button"







                  className="btn bp"







                  style={{







                    flex: 1,







                  }}







                  onClick={







                    handleUpdateProfile







                  }







                  disabled={







                    saving ||







                    roleLoading







                  }







                >







                  <I







                    n="check"







                    s={14}







                    c="#fff"







                  />















                  {saving







                    ? "Updating..."







                    : "Update Profile"}







                </button>















                <button







                  type="button"







                  className="btn bg_"







                  onClick={







                    handleCancelEdit







                  }







                  disabled={saving}







                >







                  Cancel







                </button>







              </div>







            </>







          ) : (







            <>







              <div







                style={{







                  fontWeight: 700,







                  fontSize: 12,















                  color:







                    "var(--t3)",















                  textTransform:







                    "uppercase",















                  letterSpacing:







                    ".07em",















                  marginBottom: 14,







                }}







              >







                Contact Information







              </div>















              {[







                [







                  "Full Name",







                  displayName,







                  "users",







                ],















                [







                  "Email Address",







                  form.email,







                  "mail",







                ],















                [







                  "Phone Number",







                  form.phone,







                  "phone",







                ],















                [







                  "Role",







                  form.role,







                  "shield",







                ],







              ].map(







                ([







                  key,







                  value,







                  icon,







                ]) => (







                  <div







                    key={key}







                    className="dr"







                  >







                    <div







                      style={{







                        display:







                          "flex",















                        alignItems:







                          "center",















                        gap: 7,







                      }}







                    >







                      <I







                        n={icon}







                        s={14}







                        c="var(--t3)"







                      />















                      <span className="dk">







                        {key}







                      </span>







                    </div>















                    <span className="dv">







                      {value ===







                        null ||







                        value ===







                        undefined ||







                        value === ""







                        ? "-"







                        : String(







                          value







                        )}







                    </span>







                  </div>







                )







              )}







            </>







          )}







          <div







            style={{







              marginTop: 24,















              paddingTop: 18,















              borderTop:







                "1px solid var(--bd)",







            }}







          >







            <button







              type="button"







              className="btn btn-d"







              style={{







                width: "100%",















                justifyContent:







                  "center",







              }}







              onClick={() =>







                setShowLogoutPopup(







                  true







                )







              }







            >







              <I







                n="logout"







                s={13}







              />















              Logout







            </button>







          </div>







        </div>







        {showLogoutPopup && (







          <div







            onClick={() =>







              setShowLogoutPopup(







                false







              )







            }







            style={{







              position: "fixed",







              inset: 0,















              background:







                "rgba(15,23,42,.45)",















              display: "flex",















              alignItems:







                "center",















              justifyContent:







                "center",















              zIndex: 9999,















              padding: 20,







            }}







          >







            <div







              onClick={(e) =>







                e.stopPropagation()







              }







              style={{







                width:







                  "min(390px,92vw)",















                background:







                  "#fff",















                borderRadius: 12,















                boxShadow:







                  "0 20px 50px rgba(0,0,0,.2)",















                overflow:







                  "hidden",







              }}







            >







              <div







                style={{







                  padding:







                    "18px 20px",















                  borderBottom:







                    "1px solid var(--bd)",















                  fontWeight: 800,















                  fontSize: 16,







                }}







              >







                Logout







              </div>







              {!logoutSuccess ? (







                <>







                  <div







                    style={{







                      padding: 20,







                      fontSize: 14,







                      color: "var(--t2)",







                    }}







                  >







                    Are you sure you want to logout?







                  </div>















                  <div







                    style={{







                      display: "flex",







                      justifyContent: "flex-end",







                      gap: 10,







                      padding: "0 20px 20px",







                    }}







                  >







                    <button







                      type="button"







                      className="btn bg_"







                      onClick={() => setShowLogoutPopup(false)}







                    >







                      Cancel







                    </button>















                    <button







                      type="button"







                      className="btn btn-d"







                      onClick={handleLogout}







                    >







                      Logout







                    </button>







                  </div>







                </>







              ) : (







                <div







                  style={{







                    margin: 20,







                    padding: "14px 16px",







                    borderRadius: 8,







                    backgroundColor: "#d1e7dd",







                    color: "#0f5132",







                    border: "1px solid #badbcc",







                    fontWeight: 600,







                    textAlign: "center",







                  }}







                >







                  ✓ You have logged out successfully.







                </div>







              )}







            </div>







          </div>







        )}







      </div>







    </div>







  );







}